import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import MaterialTable from "@material-table/core";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import "./loader.css";
import "./pharmacy.css";

const Pharmacy = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem("isLoggedIn");
    if (isAuthenticated !== "true") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("https://api.sgtu.ac.in/api/pharmacyForm");
        const data = res.data.map((item) => ({
          ...item,
        }));
        setTableData(data);
        setLoading(false);
      } catch (error) {
        toast.error("Error Fetching Data");
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleExcelDownload = async () => {
    try {
      const response = await axios.get(
        "https://api.sgtu.ac.in/api/pharmacyForm/export/excel",
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "pharmacy_data.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toast.error("Failed to download Excel");
    }
  };

  const columns = [
    { title: "Name", field: "student_name" },
    { title: "Father Name", field: "father_name" },
    {
      title: "Aadhaar Front",
      render: (rowData) => (
        <button
          onClick={() =>
            window.open(
              `https://api.sgtu.ac.in/api/pharmacyForm/view/${rowData._id}/aadhaar_front`,
              "_blank"
            )
          }
          className="view-button"
        >
          View
        </button>
      ),
    },
    {
      title: "Aadhaar Back",
      render: (rowData) => (
        <button
          onClick={() =>
            window.open(
              `https://api.sgtu.ac.in/api/pharmacyForm/view/${rowData._id}/aadhaar_back`,
              "_blank"
            )
          }
          className="view-button"
        >
          View
        </button>
      ),
    },
    {
      title: "Photo",
      render: (rowData) => (
        <button
          onClick={() =>
            window.open(
              `https://api.sgtu.ac.in/api/pharmacyForm/view/${rowData._id}/photo`,
              "_blank"
            )
          }
          className="view-button"
        >
          View
        </button>
      ),
    },
    {
      title: "10th Marksheet",
      render: (rowData) => (
        <button
          onClick={() =>
            window.open(
              `https://api.sgtu.ac.in/api/pharmacyForm/view/${rowData._id}/secondary/doc`,
              "_blank"
            )
          }
          className="view-button"
        >
          View
        </button>
      ),
    },
    {
      title: "12th Marksheet",
      render: (rowData) => (
        <button
          onClick={() =>
            window.open(
              `https://api.sgtu.ac.in/api/pharmacyForm/view/${rowData._id}/sr_secondary/doc`,
              "_blank"
            )
          }
          className="view-button"
        >
          View
        </button>
      ),
    },
    {
      title: "Graduation Marksheet",
      render: (rowData) => (
        <button
          onClick={() =>
            window.open(
              `https://api.sgtu.ac.in/api/pharmacyForm/view/${rowData._id}/graduation/doc`,
              "_blank"
            )
          }
          className="view-button"
        >
          View
        </button>
      ),
    },
    {
      title: "Post-Graduation Marksheet",
      render: (rowData) => (
        <button
          onClick={() =>
            window.open(
              `https://api.sgtu.ac.in/api/pharmacyForm/view/${rowData._id}/post_graduation/doc`,
              "_blank"
            )
          }
          className="view-button"
        >
          View
        </button>
      ),
    },
  ];

  return (
    <div className="dashboard-wrapper">
      <Toaster position="top-center" />
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
      />
      <main className="dashboard-main">
        <Header />
        <div className="main-section">
          {loading ? (
            <div className="loader-main">
              <div className="loader-box">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          ) : (
            <div className="material-table-wrapper">
              <MaterialTable
                title="Pharmacy Data"
                data={tableData}
                columns={columns}
                actions={[
                  {
                    icon: () => (
                      <button className="excel-download-btn">
                        Download Excel
                      </button>
                    ),
                    tooltip: "Download Excel",
                    isFreeAction: true,
                    onClick: handleExcelDownload,
                  },
                ]}
                options={{
                  search: true,
                  paging: true,
                  pageSize: 10,
                  exportButton: false,
                  headerStyle: {
                    whiteSpace: "nowrap",
                    fontWeight: "bold",
                    fontSize: "12px",
                    padding: "6px 8px",
                  },
                  rowStyle: {
                    whiteSpace: "nowrap",
                    fontSize: "11px",
                    paddingTop: 4,
                    paddingBottom: 4,
                  },
                  tableLayout: "auto",
                  overflowX: "auto",
                }}
              />
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Pharmacy;
